// Module
var code = `<!-- ko using: model -->
<div class="svc-creator-tab__content">
  <div class="svc-plugin-tab__content svc-logic-tab__content" data-bind="css: { 'svc-logic-tab--empty': !hasItems }">
    <!-- ko template: { name: 'survey-content', data: itemsSurvey  } -->
    <!-- /ko -->
    <!-- ko if: !hasItems -->
    <div class="svc-logic-tab__content-empty">
      <svc-surface-placeholder params="name: 'logic', placeholderTitleText: \$data.placeholderTitleText, placeholderDescriptionText: \$data.placeholderDescriptionText"></svc-surface-placeholder>
    </div>
    <!-- /ko -->
    <!-- ko if: !readOnly -->
    <div role="button" class="svc-logic-tab__content-action svc-btn" data-bind="click: addNewButton.action, key2click, clickBubble: false, css: {'svc-logic-tab__content-action--disabled': (addNewButton.enabled !== undefined && !addNewButton.enabled) }">
      <span class="svc-btn__text" data-bind="text: addNewButton.title">
      </span>
    </div>
    <!-- /ko -->
  </div>
</div>
<!-- /ko -->`;
// Exports
export default code;